<template>
    <console-content max-width="1600">

        <v-row class="mt-0 mt-md-4 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg">본인인증 목록</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="tit tit--xs font-weight-bold">검색필터</v-card-title>
                <v-card-text class="pb-0">
                    <v-row align="center">
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.searchKey" label="검색조건" persistent-placeholder hide-details :items="searchKeys" item-text="text" item-value="value" @input="filter.searchValue = null;"/>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page=1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-6 px-1" align="end">
            <v-col cols="auto">
                <span class="ception">검색된 본인인증 회원: {{ summary.totalCount.format() }}</span>
            </v-col>
            <v-spacer />
        </v-row>

        <v-data-table :loading="loading" :items="certs" :headers="membersHeaders" hide-default-footer disable-sort class="mt-2 mx-1 elevation-1">

            <template v-slot:item.phone="{item}">
                <span>{{ item.phone.phoneNumberFormat() }}</span>
            </template>
            <template v-slot:item.createdAt="{item}">
                <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-4" @input="search(true)" />

    </console-content>
</template>

<script>
import api from "@/api";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel, mdiPlusCircleMultipleOutline, mdiRefresh, mdiAlertCircleOutline } from "@mdi/js";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";

export default {
    components: {
        ConsoleContent,
        VDateField
    },
    data(){
        return {
            mdiRefresh,
            mdiMicrosoftExcel,
            mdiPlusCircleMultipleOutline,
            mdiAlertCircleOutline,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "name" },
                { text: "연락처", value: "phone" },
                { text: "생일", value: "birthday" }
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,
            loading: true,

            certs: [],
            summary: { totalCount: 0 },
            membersHeaders: [
                { text: "회원이름", value: "name", align: "center", width: "10%" },
                { text: "연락처", value: "phone", align: "center", width: "10%" },
                { text: "생일", value: "birthday", align: "center", width: "10%" },
                { text: "생성일자", value: "createdAt", align: "center", width: "15%" },
                { text: "CI 값", value: "ci", align: "left", width: "70%" }
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            this.loading = true;
            this.certs = [];
            let { summary, certs } = await api.console.auth.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            })
            this.loading = false;
            this.certs = certs;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    }
}
</script>